// extracted by mini-css-extract-plugin
export var hidden = "_6w-1";
export var visible = "_6w-0";